<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <base-input 
          v-uppercase 
          v-model="service.label" 
          label="Name" 
        />
        <base-input label="Select Service Category">
          <el-select
            v-model="service.serviceCategoryIds"
            multiple
            style="width: 100%;"
          >
            <el-option
              v-for="item in serviceCategories"
              :key="item.serviceCategoryId"
              :value="item.serviceCategoryId"
              :label="item.label"
            />
          </el-select>
        </base-input>
      </div>
    </div>
    <base-button 
      md 
      type="primary" 
      @click="onSubmit()">Save</base-button>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { Select, Option } from "element-ui";
export default {
  directives: {
    uppercase: {
      inserted: function (el, _, vnode) {
        el.addEventListener("input", async function (e) {
          const modified = e.target.value
            .split(" ")
            .map((i) => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      },
    },
  },
  data: () => {
    return {};
  },

  computed: {
    ...mapState("service", ["service"]),
    ...mapGetters({
      serviceCategories: "serviceCategory/getServiceCategoryList",
      serviceList: "service/getServiceList",
    }),
  },

  mounted() {
    this.getServiceCategoryList();
  },

  methods: {
    ...mapActions({
      saveService: "service/saveService",
      getServiceList: "service/getServiceList",
      getServiceCategoryList: "serviceCategory/getServiceCategoryList",
      updateService: "service/updateService",
    }),

    duplicateMessage() {
      const label = (this.service.label || "").trim().toLowerCase();
      const categoryIds = this.selectedCategoryIds();
      if (!label || !categoryIds.length) return "";
      const exists = (this.serviceList || []).some((row) => {
        if (row.serviceId === this.service.serviceId) return false;
        if ((row.label || "").trim().toLowerCase() !== label) return false;
        const rowIds = this.categoryIdsOf(row);
        return categoryIds.some((id) => rowIds.indexOf(id) !== -1);
      });
      return exists
        ? "This service already exists in the selected category."
        : "";
    },
    categoryIdsOf(row) {
      if (row.serviceCategoryIds && row.serviceCategoryIds.length) {
        return row.serviceCategoryIds;
      }
      return row.serviceCategoryId ? [row.serviceCategoryId] : [];
    },
    selectedCategoryIds() {
      const ids = Array.isArray(this.service.serviceCategoryIds)
        ? this.service.serviceCategoryIds.filter(Boolean)
        : [];
      return ids.filter((id, index) => ids.indexOf(id) === index);
    },
    notifySaveError(err) {
      const details =
        err && err.response && err.response.data && err.response.data.details;
      if (Array.isArray(details) && details.length) {
        details.forEach((item) => {
          this.$notify({
            message: item.message,
            type: "danger",
            title: "Validation Error",
          });
        });
        return;
      }
      this.$notify({
        message: "Could not save.",
        type: "danger",
        title: "Error",
      });
    },
    onSubmit() {
      const categoryIds = this.selectedCategoryIds();
      this.service.serviceCategoryIds = categoryIds;
      this.service.serviceCategoryId = categoryIds[0] || null;
      const duplicate = this.duplicateMessage();
      if (duplicate) {
        this.$notify({
          message: duplicate,
          type: "danger",
          title: "Validation Error",
        });
        return;
      }
      if (this.service.serviceId) {
        this.updateService().then((res) => {
          this.$notify({
            message: "Service Updated Succesfully!",
            type: "success",
            title: "Succes",
          });
          this.getServiceList();
          this.$emit("close");
        }).catch((err) => this.notifySaveError(err));
      } else {
        this.saveService().then((res) => {
          this.$notify({
            message: "Service Created Succesfully!",
            type: "success",
            title: "Success",
          });
          this.getServiceList();
          this.$emit("close");
        }).catch((err) => this.notifySaveError(err));
      }
    },
  },

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
};
</script>